<template>
  <div class="allocation-manager">
    <div class="allocation-options">
      <div
        id="openShare"
        class="options"
        :class="{ 'disabled-option': totalSharableQty < 1 }"
        @click="$emit('open-share')"
      >
        <div>
          <ns-icon icon-name="icon-gift" />
        </div>
        <div>
          <h3>{{ tdc.tdc_transferAllocationTitle }}</h3>
          <p class="paragraph-s">{{ tdc.tdc_transferAllocationText }}</p>
        </div>
        <div>
          <ns-icon icon-name="icon-narrow-angle-right-24" />
        </div>
      </div>
      <div
        id="openStatus"
        class="options"
        :class="{ 'disabled-option': totalSharedQty < 1 }"
        @click="$emit('open-status')"
      >
        <div>
          <ns-icon icon-name="icon-email-sent" />
        </div>
        <div>
          <h3>{{ tdc.tdc_transferStatusTitle }}</h3>
          <p class="paragraph-s">{{ tdc.tdc_transferStatusText }}</p>
        </div>
        <div>
          <ns-icon icon-name="icon-narrow-angle-right-24" />
        </div>
      </div>
      <div
        id="openReturn"
        class="options"
        :class="{ 'disabled-option': !canShareBack }"
        @click="$emit('open-return')"
      >
        <div>
          <ns-icon icon-name="icon-return" />
        </div>
        <div>
          <h3>{{ tdc.tdc_returnAllocationTitle }}</h3>
          <p class="paragraph-s">{{ tdc.tdc_returnAllocationText }}</p>
        </div>
        <div>
          <ns-icon icon-name="icon-narrow-angle-right-24" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { NsIcon } from '@nuskin/ns-icon'
import config from '../js/qualificationsConfigService'

export default {
  data() {
    return {
      tdc: config.getTdc(),
    }
  },
  name: 'ManagerOptions',
  components: {
    NsIcon,
  },
  props: {
    totalSharableQty: Number,
    totalSharedQty: Number,
    canShareBack: Boolean,
  },
}
</script>

<style lang="scss" scoped>
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/colors";
@use "~@nuskin/ns-core-styles/src/scss/global.mixins";

.options {
  display: flex;
  padding: 20px;
  box-sizing: border-box;
  cursor: pointer;
  border: 1px solid map.get(colors.$baseColors, "gandalf");
  border-radius: 6px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);
  margin-bottom: 20px;
  max-width: 450px;
  background-color: map.get(colors.$baseColors, "basewhite");

  & > div:first-child {
    min-width: 20px;
    margin-right: 14px;
  }

  & > div:nth-child(2) {
    flex-grow: 1;
  }

  &.disabled-option {
    color: map.get(colors.$baseColors, "eyore");
    cursor: not-allowed;
    pointer-events: none;
    box-shadow: none;

    .icon,
    h3,
    p {
      color: map.get(colors.$baseColors, "eyore");
    }
  }
}
.icon {
  color: map.get(colors.$baseColors, "shells");
  height: 20px;
  width: 20px;
}

h3 {
  color: map.get(colors.$baseColors, "shells");
  @include global.heading-3();
}
</style>
